import React from 'react';

import BonusTable from './BonusTable';
import ErrorFeedbackBar from '.././global/ErrorFeedbackBar';
import { BONUS_PAGES, CUSTOMER_BONUS_FIELDS } from './constants';
import FeedbackBar from '../feedbackBar/FeedbackBar';
import withShipment from '../../withShipment';
import { statusSelector } from '../../redux/selectors/global';
import { clearStatus } from '../../redux/actions/global';
import { userInfoSelector } from '../../redux/selectors/auth';
import {
  Button,
  CircularProgress,
  TableCell,
  TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  bonusSelector,
  claimBonusSelector,
  loadingSelector,
  manageBonusSelector,
  previewBonusSelector,
} from '../../redux/selectors/settings';
import {
  deleteBonus,
  listClaimBonus,
  listManageBonus,
  previewBonusImage,
  saveBonus,
  uploadBonusPhoto,
} from '../../redux/actions/settings';
import { AddAPhoto, Clear } from '@material-ui/icons';
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';
import TablePage from '../global/Table/TablePage';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import {
  clearAllCustomers,
  listRaffleCustomers,
} from '../../redux/actions/customer';
import { raffleCustomersSelector } from '../../redux/selectors/customer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Layout } from '../global/Table/TablePageHelpers/LayoutObject';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { BACK } from '../reading/masterReading/constants';
import { Stack } from '@mui/material';
import SessionReportPdf from '../global/SessionReportPdf';
import CustomToolbar from '../global/CustomToolbar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { addPendingPhoto } from './photoOutbox';

// Block a second tap for this long after a save fires (prevents double-submit)
const SAVE_COOLDOWN_MS = 2000;

// Longest edge of the captured photo. Full-resolution captures reach
// multi-MB and stall on slow store connections; 1600px keeps the JPEG at
// a few hundred KB so the background upload finishes in seconds.
const MAX_PHOTO_EDGE = 1600;

class Bonus extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.canvasRef = React.createRef();
    this._isMounted = false; // guards all setState calls after unmount
    this.state = {
      currentPage: BONUS_PAGES.TABLE,
      feedbackBarOpen: false,
      error: false,
      machine: '',
      selectedBonus: null,
      selectedSpecification: null,
      requiredList: ['machine'],
      isCameraOpen: false,
      cameraFacingMode: 'environment',
      selectedCustomer: null,
      search: '',
      hoveredRows: {},
      clickedRows: {},
      isBonus: false,
      capturedImageURL: null,
      newPhotos: null,
      isPreviewImage: false,
      image: null,
      isMobile: window.matchMedia('(max-width: 800px)').matches,
      isLoading: true,
      saveCooldown: false,
      // report
      reportTrigger: 0,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.listClaimBonus({
      userId: this.props.user.userId,
      locationId: this.props.user.selectedLocationId,
    });
    this.props.listManageBonus({
      locationId: this.props.user.selectedLocationId,
    });
    // Keep the "running now" flags fresh so the bonus picker stays accurate
    // while the terminal sits open across a schedule boundary.
    this._bonusRefreshTimer = setInterval(() => {
      if (this._isMounted) {
        this.props.listManageBonus({
          locationId: this.props.user.selectedLocationId,
        });
      }
    }, 60000);
    // NOTE: leftover outbox photos are drained by Base.jsx (app shell),
    // so they upload no matter which screen the employee opens.
  }

  componentWillUnmount() {
    this._isMounted = false; // prevents any queued setState from firing after unmount

    if (this._bonusRefreshTimer) clearInterval(this._bonusRefreshTimer);

    const stream = this.videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    this.props.clearAllCustomers();
  }

  // Safe setState — silently drops the call if component already unmounted.
  // Use this everywhere a callback or async path calls setState.
  safeSetState = (state, callback) => {
    if (this._isMounted) {
      this.setState(state, callback);
    }
  };

  async componentDidUpdate(prevProps) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar();
    }

    if (prevProps.previewImage !== this.props.previewImage) {
      this.safeSetState({ image: this.props.previewImage.localURL });
    }
  }

  handleImageLoad = () => this.safeSetState({ isLoading: false });
  handleImageError = () => this.safeSetState({ isLoading: false });

  handleMouseEnter = (index) =>
    this.setState({ hoveredRows: { [index]: true } });
  handleMouseLeave = () => this.setState({ hoveredRows: {} });

  getTableHeaders = () => {
    let headers = [];
    headers.push(Layout.columnHead(null, null, null));
    CUSTOMER_BONUS_FIELDS.forEach((headCell) => {
      headers.push(Layout.columnHead(headCell.label, headCell.id));
    });
    return headers;
  };

  tableRow = (customer, index) => {
    const isGreen =
      this.state.hoveredRows[index] || this.state.clickedRows[index];
    const { isLoading } = this.state;

    return (
      <React.Fragment>
        <TableCell style={{ marginLeft: '16px' }}>
          <IconButton
            size="small"
            onClick={() => this.handleEditRow(customer, index)}
            onMouseEnter={() => this.handleMouseEnter(index)}
            onMouseLeave={() => this.handleMouseLeave(index)}
            style={{
              backgroundColor: isGreen ? 'green' : 'transparent',
              color: isGreen ? 'white' : 'inherit',
            }}
          >
            <CheckCircleIcon />
          </IconButton>
        </TableCell>

        <TableCell className="table-cell-left">
          {isLoading && (
            <div className="loading-indicator">
              <CircularProgress />
            </div>
          )}
          <img
            src={customer?.files[0]?.localURL}
            alt="Customer"
            className="responsive-image-customer"
            onLoad={this.handleImageLoad}
            onError={this.handleImageError}
          />
        </TableCell>

        <TableCell className="table-cell-left">{customer?.firstName}</TableCell>
        <TableCell className="table-cell-left">{customer?.lastName}</TableCell>
        <TableCell className="table-cell-left">{customer?.tagId}</TableCell>
      </React.Fragment>
    );
  };

  handleEditBonusRow = (photo) => {
    if (!photo) {
      this.openFeedbackBar(
        'error',
        'Background image is uploading... please retry in a few minutes and refresh the page.'
      );
      return;
    }

    const match = photo.match(/path:([^\]]+)/);
    if (match) {
      this.setState({ isPreviewImage: true }, () => {
        const path = match[1].trim();
        if (path) {
          this.props.previewBonusImage({ path: path });
        }
      });
    }
  };

  getFormattedFileObject = async (file) => {
    return {
      localURL: URL.createObjectURL(file),
      displayName: file.name,
      type: file.type,
      file,
    };
  };

  stopCamera = () => {
    const stream = this.videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    this.setState({ isCameraOpen: false });
  };

  startCamera = async () => {
    try {
      const existing = this.videoRef.current?.srcObject;
      if (existing) {
        existing.getTracks().forEach((track) => track.stop());
      }

      const constraints = {
        video: {
          facingMode: { ideal: this.state.cameraFacingMode },
          width: { min: 1024, ideal: 1920, max: 3840 },
          height: { min: 720, ideal: 1080, max: 2160 },
          frameRate: { ideal: 60 },
        },
        audio: false,
      };

      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      const track = stream.getVideoTracks()[0];
      const capabilities = track.getCapabilities ? track.getCapabilities() : {};
      if (capabilities.focusMode?.includes('continuous')) {
        await track.applyConstraints({
          advanced: [{ focusMode: 'continuous' }],
        });
      }

      this.safeSetState({ isCameraOpen: true });
      if (this.videoRef.current) {
        this.videoRef.current.srcObject = stream;
      }
    } catch (err) {
      alert('Camera access error: ' + err.message);
    }
  };

  switchCamera = () => {
    const nextFacingMode =
      this.state.cameraFacingMode === 'environment' ? 'user' : 'environment';
    this.safeSetState({ cameraFacingMode: nextFacingMode }, () => {
      if (this.state.isCameraOpen) {
        this.startCamera();
      }
    });
  };

  capturePhoto = () => {
    const canvas = this.canvasRef.current;
    const video = this.videoRef.current;

    if (canvas && video) {
      const vWidth = video.videoWidth;
      const vHeight = video.videoHeight;
      const screenAspectRatio = window.innerWidth / window.innerHeight;
      const videoAspectRatio = vWidth / vHeight;

      let sWidth, sHeight, sx, sy;
      if (videoAspectRatio > screenAspectRatio) {
        sWidth = vHeight * screenAspectRatio;
        sHeight = vHeight;
        sx = (vWidth - sWidth) / 2;
        sy = 0;
      } else {
        sWidth = vWidth;
        sHeight = vWidth / screenAspectRatio;
        sx = 0;
        sy = (vHeight - sHeight) / 2;
      }

      // Downscale so the upload is a few hundred KB, not multi-MB —
      // critical for the background upload on slow store connections.
      const scale = Math.min(1, MAX_PHOTO_EDGE / Math.max(sWidth, sHeight));
      canvas.width = Math.round(sWidth * scale);
      canvas.height = Math.round(sHeight * scale);

      const ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(
        video,
        sx,
        sy,
        sWidth,
        sHeight,
        0,
        0,
        canvas.width,
        canvas.height
      );

      const imageURL = canvas.toDataURL('image/jpeg', 0.9);
      this.setState({ capturedImageURL: imageURL }, () => this.stopCamera());
      this.handleFileAdd(imageURL);
    }
  };

  handleOpenCamera = () => {
    if (!this.state.isCameraOpen) {
      this.startCamera();
    }
  };

  setCurrentPage = (newPage) => this.setState({ currentPage: newPage });

  displayTable = () => (
    <BonusTable
      userInfo={this.props.user}
      deleteBonus={this.props.deleteBonus}
      setCurrentPage={this.setCurrentPage}
      openFeedbackBar={this.openFeedbackBar}
      claimBonus={this.props.claimBonus}
      handleEditBonusRow={this.handleEditBonusRow}
      isPreviewImage={this.state.isPreviewImage}
      image={this.state.image}
    />
  );

  displayCurrentPage = () => {
    switch (this.state.currentPage) {
      case BONUS_PAGES.TABLE:
        return this.displayTable();
      default:
        return <div>We encountered an error. Please refresh the page.</div>;
    }
  };

  openFeedbackBar = (status, message) => {
    this.safeSetState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => this.props.clearStatus()
    );
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    const reg = /^[0-9\b]+$/;
    if (value === '' || reg.test(value)) {
      this.setState({ [name]: value });
    }
  };

  fetchSearch = (name) => {
    this.props.listRaffleCustomers({
      search: name,
      locationId: this.props.user.selectedLocationId,
    });
  };

  handleSearchChange = (name, e) => {
    const { value } = e.target;
    this.setState({ [name]: value });
    if (value.trim() === '') {
      this.setState({
        selectedCustomer: null,
        hoveredRows: {},
        clickedRows: {},
      });
      this.props.clearAllCustomers();
    }
  };

  handleBlur = (e) => {
    this.trimField(e);
    if (e.target.value.trim() !== '') {
      this.fetchSearch(this.state.search);
    }
  };

  clearFields = () => {
    this.setState({
      machine: '',
      selectedBonus: null,
      selectedSpecification: null,
    });
  };

  handleBonusChange = (event) => {
    this.setState({ selectedBonus: event.target.value });
  };

  // Employees may only give a bonus that is active AND running right now
  // (spec BR-05/BR-08). Inactive and out-of-window bonuses are hidden from the
  // picker; the server enforces the same rule on save as a safety net.
  getSelectableBonuses = () =>
    (this.props.manageBonus || []).filter((b) => b.enabled && b.isRunningNow);

  handleEditRow = (selectedCustomer, rowIndex) => {
    this.setState({ selectedCustomer, clickedRows: { [rowIndex]: true } });
  };

  trimField = (e) => {
    this.setState({ [e.target.name]: e.target.value.trim() });
  };

  handleFileAdd = async (fileDataURL) => {
    const res = await fetch(fileDataURL);
    const blob = await res.blob();
    const file = new File(
      [blob],
      `${Date.now() + Math.floor(Math.random() * 10000)}.jpeg`,
      { type: blob.type }
    );
    const newFile = await this.getFormattedFileObject(file);
    this.safeSetState({
      newPhotos: newFile,
      capturedImageURL: newFile.localURL,
    });
  };

  addBonusPoint = () => {
    if (this.state.saveCooldown || !this.state.newPhotos?.file) return;

    const {
      machine,
      newPhotos,
      selectedBonus,
      selectedSpecification,
      selectedCustomer,
    } = this.state;
    const { user } = this.props;

    // Reset form immediately (keep optimistic pattern)
    this.setState(
      {
        isBonus: false,
        search: '',
        newPhotos: null,
        capturedImageURL: null,
        isCameraOpen: false,
        hoveredRows: {},
        clickedRows: {},
        selectedCustomer: null,
        saveCooldown: true,
      },
      () => {
        this.clearFields();
        this.props.clearAllCustomers();
        setTimeout(
          () => this.safeSetState({ saveCooldown: false }),
          SAVE_COOLDOWN_MS
        );
      }
    );

    // Request A — fast JSON save, get bonusId back
    this.props.saveBonus(
      {
        machine,
        userId: user.userId,
        locationId: user.selectedLocationId,
        customerId: selectedCustomer.customerId,
        manageBonusId: selectedBonus.manageBonusId,
        specification: selectedSpecification,
      },
      (status, response) => {
        if (!status) {
          this.openFeedbackBar(
            'error',
            `Bonus could not be saved: ${response}.`
          );
          return;
        }

        // Request B — persist the photo to the on-device outbox, then let
        // the background queue saga upload it (retries; survives reloads).
        const photoEntry = {
          bonusId: response.bonusId,
          phone: selectedCustomer.phone,
          displayName: newPhotos.displayName,
          blob: newPhotos.file,
        };
        addPendingPhoto(photoEntry)
          .catch(() => {}) // outbox is best-effort; upload proceeds anyway
          .then(() => this.props.uploadBonusPhoto(photoEntry));
      }
    );
  };

  // ── Report helpers ──────────────────────────────────────────────────────────

  // Generates the new employee-session PDF for this employee's latest shift
  // (bumping reportTrigger fires SessionReportPdf).
  fetchPdf = () => {
    this.safeSetState((s) => ({ reportTrigger: s.reportTrigger + 1 }));
  };

  handleReportError = (message) => {
    this.openFeedbackBar('error', message);
  };

  render() {
    const { isMobile, isBonus, isPreviewImage, isCameraOpen, capturedImageURL } =
      this.state;

    let headerButtons = [];

    if (
      !this.state.isPreviewImage &&
      !this.state.isBonus &&
      !this.state.isMobile
    ) {
      headerButtons.push({
        icon: <VisibilityIcon />,
        title: 'View Report',
        handler: () => this.fetchPdf(),
      });
    }

    if (this.state.isBonus) {
      headerButtons.push({
        icon: <KeyboardBackspaceIcon />,
        handler: () => {
          this.setState(
            {
              isBonus: false,
              search: '',
              newPhotos: null,
              capturedImageURL: null,
              selectedCustomer: null,
              hoveredRows: {},
              clickedRows: {},
            },
            () => {
              this.props.clearAllCustomers();
              this.clearFields();
              if (this.state.isCameraOpen) this.stopCamera();
            }
          );
        },
        title: BACK,
      });
    }

    if (this.state.isPreviewImage) {
      headerButtons.push({
        icon: <KeyboardBackspaceIcon />,
        handler: () => this.setState({ isPreviewImage: false }),
        title: BACK,
      });
    }

    // Disabled only during the 2-second cooldown or while photo isn't ready yet.
    // No isSaving flag needed — optimistic pattern has no loading state.
    const addBonusDisabled =
      this.state.saveCooldown || !this.state.newPhotos?.file;

    return (
      <React.Fragment>
        <ErrorFeedbackBar />
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        <CustomToolbar
          title={`Bonus (${this.props.user.firstname})`}
          createTitle={''}
          backTitle={''}
          headerButtons={headerButtons}
        />

        {isMobile ? (
          <>
            {!isBonus && !isPreviewImage && (
              <div>
                <div className="rowSpecMaster">
                  <TextField
                    className="input-text-field"
                    variant="outlined"
                    label="Machine"
                    InputLabelProps={{ shrink: true }}
                    name="machine"
                    value={this.state.machine}
                    onChange={this.handleChange}
                    required={this.state.requiredList.includes('machine')}
                    type="tel"
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      min: '0',
                      step: '1',
                    }}
                  />

                  <div className="rowSpecBonus">
                    <Autocomplete
                      className="input-text-field-bonus"
                      options={this.getSelectableBonuses()}
                      getOptionLabel={(option) => option.name}
                      value={this.state.selectedBonus || null}
                      onChange={(e, value) =>
                        this.handleBonusChange({
                          target: {
                            name: 'selectedBonus',
                            value: value || null,
                          },
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="bonus"
                          label="Bonus"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    />
                  </div>

                  {this.state.selectedBonus?.specifications && (
                    <div className="rowSpecBonus">
                      <Autocomplete
                        className="input-text-field-bonus"
                        options={this.state.selectedBonus.specifications}
                        getOptionLabel={(option) => `${option.description}`}
                        value={this.state.selectedSpecification}
                        onChange={(e, value) =>
                          this.setState({ selectedSpecification: value })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="specify"
                            label="Specify"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    </div>
                  )}
                </div>

                <div className="button-ticket" style={{ marginTop: 16 }}>
                  <Button
                    variant="outlined"
                    onClick={this.clearFields}
                    className="register-new-user_btn"
                  >
                    CLEAR
                  </Button>
                  <Button
                    className="register-new-user_btn"
                    variant="contained"
                    color="primary"
                    onClick={() => this.setState({ isBonus: true })}
                    disabled={
                      !(
                        this.state.machine &&
                        this.state.selectedBonus &&
                        this.state.selectedSpecification
                      )
                    }
                  >
                    ADD BONUS
                  </Button>
                </div>
              </div>
            )}

            {isBonus ? (
              <div style={{ marginTop: '24px' }}>
                <div style={{ marginTop: '24px' }}>
                  {/* Step 1: Open camera */}
                  {!isCameraOpen && !capturedImageURL && (
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{ mt: 3, mb: 3 }}
                      style={{ marginLeft: '16px', marginRight: '16px' }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={this.handleOpenCamera}
                        startIcon={<AddAPhoto />}
                        aria-label="Open Camera"
                      >
                        Open Camera
                      </Button>
                    </Stack>
                  )}

                  {isCameraOpen && (
                    <div className="camera-view-container">
                      <video
                        ref={this.videoRef}
                        autoPlay
                        playsInline
                        muted
                        className="video-ref"
                      />
                      <button
                        onClick={this.capturePhoto}
                        className="capture-button"
                        aria-label="Capture Photo"
                      >
                        <span className="capture-icon"></span>
                      </button>
                      <button
                        type="button"
                        onClick={this.switchCamera}
                        className="flip-camera-button"
                        aria-label="Switch Camera"
                      >
                        <FlipCameraIosIcon />
                      </button>
                    </div>
                  )}

                  <canvas ref={this.canvasRef} style={{ display: 'none' }} />

                  {/* Step 2: Preview captured photo */}
                  {!isCameraOpen && capturedImageURL && (
                    <div style={{ marginTop: '16px', textAlign: 'center' }}>
                      <img
                        className="responsive-image-bonus"
                        src={capturedImageURL}
                        alt="Captured"
                        style={{ maxWidth: '50%', borderRadius: '8px' }}
                      />
                    </div>
                  )}

                  {/* Step 3: Search customer */}
                  {capturedImageURL && (
                    <div style={{ padding: '16px' }}>
                      <Button
                        startIcon={<AddAPhoto />}
                        onClick={this.handleOpenCamera}
                        className="retake-btn"
                      >
                        Retake Photo
                      </Button>

                      <TextField
                        className="input-text-field"
                        margin="dense"
                        id="outlined-basic"
                        label="Search Customer"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment>
                              <IconButton
                                className="clear-button"
                                onClick={() => {
                                  this.setState(
                                    {
                                      search: '',
                                      selectedCustomer: null,
                                      hoveredRows: {},
                                      clickedRows: {},
                                    },
                                    () => this.props.clearAllCustomers()
                                  );
                                }}
                              >
                                <Clear />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                        onChange={(e) => this.handleSearchChange('search', e)}
                        onBlur={this.handleBlur}
                        value={this.state.search}
                      />
                    </div>
                  )}

                  {capturedImageURL &&
                    this.props.raffleCustomers?.length > 0 && (
                      <div style={{ marginTop: '-16px' }}>
                        <TablePage
                          tableName="CustomerTable"
                          tableRows={this.props.raffleCustomers}
                          tableColumnHeads={this.getTableHeaders()}
                          tableRow={this.tableRow}
                          defaultSortBy="name"
                        />
                      </div>
                    )}

                  {/* Step 4: Confirm — taps instantly, no spinner */}
                  {capturedImageURL && this.state.selectedCustomer && (
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{ mt: 3, mb: 3 }}
                      style={{ marginLeft: '16px', marginRight: '16px' }}
                    >
                      <Button
                        variant="contained"
                        size="large"
                        className="green-bonus"
                        onClick={this.addBonusPoint}
                        startIcon={<CheckCircleIcon />}
                        aria-label="Add Bonus"
                        disabled={addBonusDisabled}
                      >
                        Add Bonus
                      </Button>
                    </Stack>
                  )}
                </div>
              </div>
            ) : (
              this.displayCurrentPage()
            )}
          </>
        ) : (
          this.displayCurrentPage()
        )}

        <SessionReportPdf
          type="bonus"
          userId={this.props.user.userId}
          locationId={this.props.user.selectedLocationId}
          locationName={this.props.user.selectedLocationName}
          trigger={this.state.reportTrigger}
          onError={this.handleReportError}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  user: userInfoSelector(state),
  manageBonus: manageBonusSelector(state),
  bonus: bonusSelector(state),
  raffleCustomers: raffleCustomersSelector(state),
  claimBonus: claimBonusSelector(state),
  previewImage: previewBonusSelector(state),
  loadingData: loadingSelector(state),
});

const actionCreators = {
  clearStatus,
  listRaffleCustomers,
  clearAllCustomers,
  listClaimBonus,
  previewBonusImage,
  saveBonus,
  listManageBonus,
  deleteBonus,
  uploadBonusPhoto,
};

export default withShipment({ actionCreators, mapStateToProps }, Bonus);
